import React from "react";
import AppRoutes from "./presentation/routes/AppRoutes";

const App: React.FC = () => (
  <AppRoutes/>
);

export default App;